import { FormEvent, useState } from "react"
import {
  Button,
  Callout,
  Card,
  Flex,
  Heading,
  Text,
  TextField,
} from "@radix-ui/themes"
import { ExclamationTriangleIcon } from "@radix-ui/react-icons"
import BaseApi from "../api/api"

export const Auth = () => {
  const [name, setName] = useState("")
  const [pass, setPass] = useState("")
  const [error, setError] = useState<string | null>(null)
  const [isLoading, setIsLoading] = useState(false)

  const login = async (e: FormEvent) => {
    e.preventDefault()
    if (isLoading) return

    setError(null)

    if (!name.trim() || !pass) {
      setError("Введите логин и пароль")
      return
    }

    setIsLoading(true)
    try {
      const result = await BaseApi.auth({
        username: name,
        password: pass,
      })
      if (!result.success) {
        setError(result.message || "Не удалось войти")
      }
    } catch {
      setError("Не удалось войти")
    } finally {
      setIsLoading(false)
    }
  }

  if (localStorage.getItem("token")) {
    location.replace("/")
    return <div></div>
  }

  return (
    <Flex align="center" justify="center" style={{ minHeight: "100vh" }}>
      <Card size="3" style={{ width: 400 }}>
        <form onSubmit={login}>
          <Flex direction="column" gap="4">
            <Heading size="6" align="center">
              Вход
            </Heading>

            <Flex direction="column" gap="1">
              <Text as="label" htmlFor="authName" size="2" weight="medium">
                Логин
              </Text>
              <TextField.Root
                id="authName"
                name="name"
                type="text"
                size="3"
                value={name}
                onChange={(e) => setName(e.target.value)}
                autoComplete="username"
                disabled={isLoading}
                placeholder="Введите логин"
              />
            </Flex>

            <Flex direction="column" gap="1">
              <Text as="label" htmlFor="authPass" size="2" weight="medium">
                Пароль
              </Text>
              <TextField.Root
                id="authPass"
                name="password"
                type="password"
                size="3"
                value={pass}
                onChange={(e) => setPass(e.target.value)}
                autoComplete="current-password"
                disabled={isLoading}
                placeholder="Введите пароль"
              />
            </Flex>

            {error && (
              <Callout.Root color="red" size="1">
                <Callout.Icon>
                  <ExclamationTriangleIcon />
                </Callout.Icon>
                <Callout.Text>{error}</Callout.Text>
              </Callout.Root>
            )}

            <Button
              type="submit"
              size="3"
              disabled={isLoading}
              style={{ width: "100%" }}
            >
              {isLoading ? "Вход..." : "Войти"}
            </Button>
          </Flex>
        </form>
      </Card>
    </Flex>
  )
}
